export default API => {
    const getAllShipping = async () => {
        try {
            const {
                data: { shipping },
            } = await API.get(`/client-settings/shipping`)
            return shipping
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const getAllFinish = async settingId => {
        try {
            const {
                data: { finishes },
            } = await API.get(`/client-settings/finish?settingId=${settingId}`)
            return finishes
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const createFinish = async params => {
        try {
            const {
                data: { finish },
            } = await API.post(`/client-settings/finish`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const updateFinish = async params => {
        try {
            const {
                data: { finish },
            } = await API.put(`/client-settings/finish`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const deleteFinish = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/finish?id=${id}&settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const getAllProfiles = async settingId => {
        try {
            const {
                data: { profiles },
            } = await API.get(`/client-settings/profile?settingId=${settingId}`)
            return profiles
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const createProfile = async params => {
        try {
            const {
                data: { profile },
            } = await API.post(`/client-settings/profile`, params)
            return profile
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const updateProfile = async params => {
        try {
            const {
                data: { profile },
            } = await API.put(`/client-settings/profile`, params)
            return profile
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const deleteProfile = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/profile?id=${id}&settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const getAllValueInputs = async settingId => {
        try {
            const {
                data: { valueInputs },
            } = await API.get(
                `/client-settings/value-inputs?settingId=${settingId}`
            )
            return valueInputs
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const updateValueInput = async params => {
        try {
            const {
                data: { valueInput },
            } = await API.put(`/client-settings/value-inputs`, params)
            return valueInput
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const deleteValueInput = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/value-inputs?id=${id}&settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const createClientSetting = async () => {
        try {
            const {
                data: { setting },
            } = await API.post('/client-settings')
            return setting
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const getLaborCostPerModule = async ({ settingId }) => {
        try {
            const {
                data: { response },
            } = await API.get(
                `/client-settings/labor-cost-per-module?settingId=${settingId}`
            )
            return response
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    const createLaborCostPerModule = async ({ settingId }) => {
        try {
            const {
                data: { response },
            } = await API.post('/client-settings/labor-cost-per-module', {
                settingId,
            })
            return response
        } catch (error) {
            const errorResponse = error.response.data
            throw new Error(errorResponse.message || errorResponse.error)
        }
    }

    return {
        getAllShipping,
        // createShipping,
        // updateShipping,
        // deleteShipping,
        getAllFinish,
        createFinish,
        updateFinish,
        deleteFinish,
        getAllProfiles,
        createProfile,
        updateProfile,
        deleteProfile,
        getAllValueInputs,
        updateValueInput,
        deleteValueInput,
        createClientSetting,
        getLaborCostPerModule,
        createLaborCostPerModule,
        // uploadShippingData,
    }
}
